import React from 'react';
import PropTypes from 'prop-types';
import {Comatose} from 'components/helpers/utils';

import '../styles/merchant-wallet-banner.less';

export default class MerchantWalletBanner extends React.Component {
  static propTypes = {
    logo: PropTypes.string,
    merchantName: PropTypes.string.isRequired,
    numBranches: PropTypes.number.isRequired,
    clearedPoints: PropTypes.number.isRequired,
    pendingPoints: PropTypes.number.isRequired,
  }

  static defaultProps = {
    logo: 'https://s3-ap-southeast-1.amazonaws.com/assets.zap.com.ph//uploads/images/7bcb50a2-7f90-478c-b90d-46e2a3dbc4a5.jpeg',
    merchantName: 'Barcino',
    numBranches: 2,
    clearedPoints: 0,
    pendingPoints: 0,
  }

  render() {
    return (
      <div id="merchant-wallet-banner">
        <div className="merchant">
          <div className="logo-info-container">
            <div className="logo">
              <img src={this.props.logo}/>
            </div>

            <div className="info">
              <div className="name">{this.props.merchantName}</div>
              <div className="branches">{this.props.numBranches} branches</div>
            </div>
          </div>

          <div className="points-info-container">
            <div className="cleared-points-container">
              <div className="points">
                <div className="value">{Comatose(this.props.clearedPoints)}</div>
                <div className="type">points</div>
              </div>
            </div>

            <div className="pending-points-container">
              <div className="points">
                <div className="value">{Comatose(this.props.pendingPoints)}</div>
                <div className="type">pending</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./js/components/widgets/MerchantWalletBanner.js